// @ts-nocheck
import React from 'react';
export const CautionIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.35247 13.3787H13.6475C14.8025 13.3787 15.5225 12.1262 14.945 11.1287L9.29747 1.37117C8.71997 0.373672 7.27997 0.373672 6.70247 1.37117L1.05497 11.1287C0.477469 12.1262 1.19747 13.3787 2.35247 13.3787ZM7.99997 8.12867C7.58747 8.12867 7.24997 7.79117 7.24997 7.37867V5.87867C7.24997 5.46617 7.58747 5.12867 7.99997 5.12867C8.41247 5.12867 8.74997 5.46617 8.74997 5.87867V7.37867C8.74997 7.79117 8.41247 8.12867 7.99997 8.12867ZM8.74997 11.1287H7.24997V9.62867H8.74997V11.1287Z"
      fill="white"
    />
  </svg>
);
